import React from 'react';
import '../about/about.css';
import './cilj.css';
import visionMedia from '../../assets/mockup/vision_media.jpg';
import { useTranslation } from 'react-i18next';

function Cilj() {
  const { t } = useTranslation('global');
  return (
    <section
      className="band-section band-section--photo band-section--tight"
      aria-labelledby="vision-title"
      style={{ '--band-photo': `url(${visionMedia})` }}
    >
      <div className="band-section__photo" aria-hidden="true" />
      <div className="band-section__grid band-section__grid--reverse bm-container">
        <div className="glass-panel glass-panel--on-photo glass-panel--edge-left">
          <h2 id="vision-title">{t('vision.our_vision')}</h2>
          <p className="glass-panel__brand">BeoMedica</p>
          <div className="glass-panel__body">
            <p>{t('vision.paragraph_1')}</p>
            <p>{t('vision.paragraph_2')}</p>
          </div>
        </div>
        <div className="band-media band-media--left band-media--spacer" aria-hidden="true" />
      </div>
    </section>
  );
}

export default Cilj;
